var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.actionTypes,"label":"Action type","item-text":"label","item-value":"value"},model:{value:(_vm.defaultType),callback:function ($$v) {_vm.defaultType=$$v},expression:"defaultType"}})}
var staticRenderFns = []

export { render, staticRenderFns }